import React from "react";
import { Row, Col, Table } from "antd";
import dataColumns from "./DataColumns";
import "./css/Report120.css";
function ReportV270({ tableGroup, sumCountGroup}) {
   const { tableV270, } = tableGroup;
   const { sumCountV270, } = sumCountGroup;
  //console.log("tableV120", sumCountV120);
  //96 px
  return (
  <>
  {tableV270 && tableV270.length > 0 ?
  <>
    <div className="divA4">
      <div className="divEdge96">
        <Row>
          <Col span={24} className="colcenter" style={{paddingTop: "10px"}}>รายงานสืบทรัพย์ก่อนฟ้อง ตามสถานะยังไม่สืบ หรือยังไม่บอกเลิก</Col>
          <Col span={24} className="colLeft18">ประเภทสัญญา : {sumCountV270[0]?.countType}</Col>
          <Col span={24} className="colLeft18" style={{paddingBottom: "10px"}}>เลือกระยะเวลาขาดการติดต่อ : {sumCountV270[0]?.countDay}</Col> 
          <Col span={24} className="colLeft18"> 
            <Table columns={dataColumns} dataSource={tableV270}  pagination={false} />
          </Col>
          <Col span={2} className="colLeft18"></Col>  
          <Col span={12} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
          จำนวนสัญญาทั้งหมด : 
          <br/>จำนวนเคสยังไม่สืบทรัพย์ : 
          <br/>จำนวนเคสยังไม่ออกบอกเลิก : 
          </Col> 
          <Col span={5} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
           {sumCountV270[0]?.countCONTNO}
          <br/>{sumCountV270[0]?.countItemA}
          <br/>{sumCountV270[0]?.countItemB}
          </Col> 

          <Col span={5} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
           เคส
          <br/>เคส
          <br/>เคส
          </Col> 
        </Row>
      </div>
    </div>
    <div style={{ pageBreakAfter: 'always' }} />
  </>  
    : []}  
  </>               
  );
}
export default ReportV270;
